import { render, staticRenderFns } from "./PaymentDetalhe.vue?vue&type=template&id=54c4ff77&scoped=true"
import script from "./PaymentDetalhe.vue?vue&type=script&lang=js"
export * from "./PaymentDetalhe.vue?vue&type=script&lang=js"
import style0 from "./PaymentDetalhe.vue?vue&type=style&index=0&id=54c4ff77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c4ff77",
  null
  
)

export default component.exports